import { useEffect } from 'react';

interface SeoJsonLdProps {
  schemas: object[];
}

export default function SeoJsonLd({ schemas }: SeoJsonLdProps) {
  useEffect(() => {
    const injected: HTMLScriptElement[] = [];

    schemas.forEach((schema, i) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = `jsonld-schema-${i}`;
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
      injected.push(script);
    });

    return () => {
      injected.forEach((script) => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
    };
  }, []);

  return null;
}
